<template>
    <div>

        Her kan du angive om du ønsker at skjule en eller flere igangværende opgaver.
        <br><br>
        <i>Bemærk, at ændringen udelukkende træder i kraft på igangværende opgaver, ikke på afsluttede, bogførte mv.</i>
        <br><br>

        <div class="placeholder">
            <div class="placeholder__heading">
                Igangværende opgaver ({{ rows.length > 0 ? rows.length : '' }})
            </div>
            <div class="placeholder">
                
                <vue-good-table
                    :columns="columns"
                    :rows="rows"
                    :searchOptions="searchOptions"
                    :paginationOptions="paginationOptions"
                    :sortOptions="sortOptions"
                    styleClass="vgt-table"
                    v-if="!loading"
                >
                    <div slot="emptystate">
                        Ingen data ...
                    </div>
                    <template slot="table-row" slot-scope="props">
                        <div v-if="props.column.field == 'description'" class="table-column__description" :title="props.row.description">
                            {{ props.row.description }}
                        </div>
                        <div v-else-if="props.column.field == 'customer.name'" class="table-column__customer" :title="props.row.customer ? props.row.customer.name : '-'">
                            {{ props.row.customer ? props.row.customer.name : '-' }}
                        </div>
                        <div v-else-if="props.column.field == 'start_date'">
                            {{ props.row.start_date | moment("DD. MMM YYYY") }}
                        </div>
                        <div class="coverage-cell" v-else-if="props.column.field == 'status.name'">
                            {{ props.row.status.name }}
                            <div class="coverage-indicator status" :style="'background:#' + props.row.status.color + ';'" />
                        </div>
                        <div v-else-if="props.column.field == 'show'">
                            <div class="coverage-indicator" v-if="props.row.show">
                                <div class="coverage-indicator good" />
                                Synlig
                            </div>
                            <div class="coverage-indicator" v-else>
                                <div class="coverage-indicator bad" />
                                Ikke synlig
                            </div>
                        </div>
                        <div v-else-if="props.column.field == 'action'">
                            <div v-if="props.row.show">
                                <button @click="updateProject(props.row, false)">
                                    Skjul
                                </button>
                            </div>
                            <div v-else>
                                <button @click="updateProject(props.row, true)">
                                    Gør synlig
                                </button>
                            </div>
                        </div>
                        <div v-else-if="props.column.field == 'minuba_external_id'">
                            <a :href="'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id" target="_blank" class="minuba-link">
                                <i class="fas fa-eye"></i>
                            </a>
                        </div>
                        <div v-else :title="props.formattedRow[props.column.field]">
                            {{ props.formattedRow[props.column.field] }}
                        </div>
                    </template>
                </vue-good-table>

                <box-loading height="350" v-else />

            </div>
        </div>

    </div>
</template>

<style lang="scss" scoped>
button {
    background: #172b43;
    color: #fff;
    padding: 2px 4px;
    border-radius: 4px;
}
</style>

<script>
import * as projectService from '@/services/projectService'

export default {
    data () {
        return {
            loading: true,
            columns: [
                { label: 'Ordre', field: 'case_number' },
                { label: 'Opgave', field: 'description' },
                { label: 'Kunde', field: 'customer.name' },
                { label: 'Startdato', field: 'start_date' },
                // { label: 'Status', field: 'status.name' },
                { label: 'Synlighed', field: 'show', type: 'number' },
                { label: 'Vis/skjul', field: 'action' }
            ],
            rows: [],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'case_number',
                    type: 'asc'
                }
            }
        }
    },
    mounted () {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' })
        }
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            let params = {
                'include': 'type,customer,status',
                'filter[status]': 'pending,ongoing,unbilled'
            }
            projectService.find(params, (response) => {
                this.rows = response.data
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        },
        updateProject (project, show) {
            let params = {
                'uuid': project.uuid,
                'show': show ? 1 : 0
            }
            projectService.update(params, (response) => {
                console.log(response)
                project.show = response.data.show
            }, (err) => {
                console.log(err)
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// excludeProjects.vue?4e95f750